<template>
  <span class="invalid-feedback" v-if="haveErrorMessage">
    {{ errorMessage }}
  </span>
</template>

<script>
export default {
  name: 'help-block',

  props: {
    field: {
      type: String,
      required: true
    },
    scope: {
      type: String,
      required: false
    }
  },

  computed: {
    haveErrorMessage () {
      return this.$parent.errors.has(this.field, this.scope)
    },

    errorMessage () {
      return this.$parent.errors.first(this.field, this.scope)
    }
  }
}
</script>
